import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLayout: null,
  selectedLayoutPlaylistItems: null,
};

const selectedLayoutSlice = createSlice({
  name: "selectedLayout",
  initialState,
  reducers: {
    setSelectedLayout: (state, action) => {
      state.selectedLayout = action.payload;
    },
    setSelectedLayoutLogout: (state) => {
      state.selectedLayout = null;
    },
    setSelectedLayoutPlaylistItems: (state, action) => {
      state.selectedLayoutPlaylistItems = action.payload;
    },
    setSelectedLayoutPlaylistItemsLogout: (state) => {
      state.selectedLayoutPlaylistItems = null;
    },
  },
});

export const {
  setSelectedLayout,
  setSelectedLayoutLogout,
  setSelectedLayoutPlaylistItems,
  setSelectedLayoutPlaylistItemsLogout,
} = selectedLayoutSlice.actions;

export default selectedLayoutSlice.reducer;
